import styled, { css } from 'styled-components';
import { ModalButtonColor } from '~/shared';

const ModalButton = styled.button.attrs<{ $type?: ModalButtonColor }>({
	tabIndex: -1,
})<{ $type?: ModalButtonColor }>`
	width: 100%;
	height: 50px;
	padding: 0 15px;
	border: 0;
	border-radius: 10px;
	cursor: pointer;
	user-select: none;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}

	${(props) =>
		props.$type === ModalButtonColor.Secondary &&
		css`
			background-color: rgba(255, 255, 255, 0.05);
			border: 1px solid rgba(255, 255, 255, 0.1);
		`}

	${(props) =>
		props.$type === ModalButtonColor.Success &&
		css`
			background-color: #1f8034;
		`}

  ${(props) =>
		props.$type === ModalButtonColor.Danger &&
		css`
			background-color: #c71e1e;
		`}

		${(props) =>
		props.$type === ModalButtonColor.Danger2 &&
		css`
			background-color: #ff3e3e;
		`}

  ${(props) =>
		props.$type === ModalButtonColor.Primary &&
		css`
			background-color: #2d70da;
		`}

  ${(props) =>
		props.$type === ModalButtonColor.Warning &&
		css`
			background-color: #e39b00;
		`}
`;

export { ModalButton };
